import { useLocation } from '@/contexts/LocationContext';
import { useCoursePricing } from './useCoursePricing';

export const useLocationPricing = (courseType: string) => {
  const { selectedState, selectedCenterId, currentStateConfig, selectedCenter } = useLocation();
  const { pricing, loading, error, getPricingForYearRange } = useCoursePricing(
    selectedState, 
    courseType, 
    selectedCenterId || undefined
  );
  
  // Check if this is center-specific pricing
  const isCenterSpecificPricing = pricing.length > 0 && pricing[0].center_id !== null;
  
  // Get the center name for display
  const centerName = selectedCenter && currentStateConfig?.centers.find(c => c.slug === selectedCenter)?.suburb;
  
  return { 
    pricing, 
    loading, 
    error,
    getPricingForYearRange,
    selectedState,
    selectedCenterId,
    currentStateConfig,
    isVIC: selectedState === 'VIC',
    isNSW: selectedState === 'NSW',
    isCenterSpecificPricing,
    centerName,
  };
};
